import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AuthService } from "./core/auth.service";

@Component({
  selector: "app-root",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly supplier = this.auth.supplier;
  readonly isLoginRoute = signal(false);

  constructor() {
    for (const evt of ["pointerdown", "keydown", "scroll", "touchstart"]) {
      window.addEventListener(evt, () => this.auth.touch(), { passive: true });
    }
    window.setInterval(() => void this.auth.refreshIfNeeded(), 60_000);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((event: NavigationEnd) => {
        this.isLoginRoute.set(
          event.urlAfterRedirects.startsWith("/login"),
        );
        // A11y: move focus to the main landmark on each navigation.
        setTimeout(() => document.getElementById("main-content")?.focus(), 0);
      });
  }

  logout() {
    void this.auth.logout().then(() => this.router.navigate(["/login"]));
  }
}
